

export const REQUEST_STATUSES = {
    submitted: 'SUBMITTED',
    pendingPayment: 'PENDING_PAYMENT',
    success: 'SUCCESS'
} as const;

export type RequestStatusMode = 'confirming' | 'finished' | null;

export function getRequestStatusMode(status?: string): RequestStatusMode {
    if (
        status === REQUEST_STATUSES.submitted ||
        status === REQUEST_STATUSES.pendingPayment
    ) {
        return 'confirming';
    }

    if (status === REQUEST_STATUSES.success) {
        return 'finished';
    }

    return null;
}